import { Component, OnInit } from "@angular/core";
import { ReportBase } from "../report.base";
import { ReportsService } from "../../../../services";
import { ActivatedRoute } from "@angular/router";
import { Store } from "@ngrx/store";
import { AppState, take, map, ClubProgram } from "../../../../store";
import { UserDisputeReport } from "../../../../models/reports/dispute-report";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AlertService } from "../../../../services/alert.service";

@Component({
  selector: "app-dispute-report",
  templateUrl: "./dispute-report.component.html",
  styleUrls: ["./dispute-report.component.css"]
})
export class DisputeReportComponent extends ReportBase implements OnInit {
  report: UserDisputeReport;
  fixOpened: boolean = false;
  user: any;

  controls = [
    { name: "name", type: "text", title: "Name" },
    {
      name: "gender",
      type: "select",
      title: "Gender",
      options: [{ text: "Male", value: "M" }, { text: "Female", value: "F" }]
    },
    { name: "fee_name", type: "text", title: "Fee Name" },


    { name: "paymentDate", type: "date", title: "Payment Date" },
    { name: "paymentAmount", type: "number", title: "Payment Amount" },
    { name: "disputeDate", type: "date", title: "Dispute Date" },
    { name: "disputeAmount", type: "number", title: "Dispute Amount" },
    {
      name: "status",
      type: "select",
      title: "Dispute Status",
      options: [
        { text: "Lost", value: "lost" }, 
        { text: "Won", value: "won" },
        { text: "Reponse needed", value: "response_needed" }
      ]
    },
    { name: "respondBy", type: "date", title: "Respond By" },
  ];

  payload = {
    userID: 0,
    stripeDisputeID: '',
    refundInfoWhen:'',
    refundInfoWhy:'',
    productDescription:'',
    customerCommunicationUrl:'',
    additionalInfo:'',
    additionalInfoUrl:''
  }

  public isOpenConfirmCorrectPopup = false;


  public popupConfirmFeePlanForm: FormGroup;
  public alphaNumericPattern = /^[a-zA-Z ]+$/;

  
  constructor(public service: ReportsService, private spinnerService: Ng4LoadingSpinnerService, private fb: FormBuilder, private alert: AlertService, public store: Store<AppState>) {
    super(service, store);
  }

  ngOnInit() {
    this.clubProgramId.pipe(take(1)).subscribe(id => {
      this.service.getDisputeReportData(id).subscribe(
        data => {
          this.report = new UserDisputeReport(data);
        },
        error => {
          this.alert.error("Could not load disputes list");
          console.log("FAILURE ======= ", error);
        }
      );
    });

    this.popupConfirmFeePlanForm = this.fb.group({
      confirmDisputeSubmit: [null, [Validators.required, Validators.pattern(this.alphaNumericPattern)]]
    });
  }

  onDisputeSubmit(event){
    this.isOpenConfirmCorrectPopup = true;
  }

  

  onCancel(event){
    this.fixOpened = false;

    this.payload.refundInfoWhen = "";
    this.payload.refundInfoWhy = "";
    this.payload.productDescription = "";
    this.payload.customerCommunicationUrl = "";
    this.payload.additionalInfo = "";
    this.payload.additionalInfoUrl = "";
  }



  submitDispute(report){
    console.log("USER DATA   ====  ", report);
    this.payload.userID = report.userID;
    this.payload.stripeDisputeID = report.disputedID;
    this.user = report;
    this.fixOpened = true;

    console.log("DISPUTE DATA   ===   ", this.payload);
  }
  searchReport(value) {
    console.log("search value:", value);
  }

  //START: FORMS UPLOAD
  onUploadCustomerCommunication(file) {
    this.payload.customerCommunicationUrl = file;
  }

  onUploadAdditionalInfomation(file){
    this.payload.additionalInfoUrl = file;
  }
  //END: FORMS UPLOAD

  //START: CONFIRMATION WINDOW
  onPopUpConfirmFeePlan(event) {
    event.stopPropagation();
    const flag = this.isCorrectTextMatched();
    if (flag) {
      this.isOpenConfirmCorrectPopup = false;
      this.spinnerService.show();
      this.service.submitDispute(this.payload).subscribe(
        (result) => {
        this.spinnerService.hide();
        this.alert.success("Evidence submitted!");
        this.fixOpened = false;
        this.ngOnInit(); //Refresh data
      }, (error) => {
        console.log("Dispute ERROR  ===  ", error);
        this.spinnerService.hide();
        this.alert.error("Evidence could not be submitted!");
      });
    } else {
      console.log("Text NOT Valid!");
    }
  }

  isCorrectTextMatched() {
    const val = this.popupConfirmFeePlanForm.get('confirmDisputeSubmit').value;
    if (val) {
      return (val.trim() === 'APPROVE') ? true : false;
    }
  }

  closePopupFeePlan() {
    this.isOpenConfirmCorrectPopup = false;
  }
  
  isConfirmCorrectValid() {
    return this.popupConfirmFeePlanForm.get('confirmDisputeSubmit').errors
      && (this.popupConfirmFeePlanForm.get('confirmDisputeSubmit').touched
        || this.popupConfirmFeePlanForm.get('confirmDisputeSubmit').dirty);
  }
  //END: CONFIRMATION WINDOW

}



// WEBPACK FOOTER //
// ./src/app/shared/clubprogram-reports/components/dispute-report/dispute-report.component.ts